import React from "react";
import { css } from "styled-components/macro";
import { NavLink } from "react-router-dom";
import { HistoryNavigatorStyle } from "../UI/history/navigatorUI";

const HistoryNavigator = props => (
  <HistoryNavigatorStyle>
    <div className="wrapper">
      {props.config.map(item => (
        <NavLink
          key={item.path}
          to={props.perfix + item.path}
          exact
          activeStyle={{
            backgroundColor: item.color
          }}
          className="button"
        >
          {item.title}
        </NavLink>
      ))}
    </div>
  </HistoryNavigatorStyle>
);
export default HistoryNavigator;
